import { Dispatch } from "react";
import { mergeClass } from "../../../utils";
import { dropdownFields } from "../../../utils/customisation";
import { getPictogramFileByName } from "../../../utils/pictograms";
import { SetStateAction } from "jotai";

interface IPreviewProps {
  itemData: any;
}

/**
 * Short cut for <div className="w-full h-full ... " />
 * @param param0
 * @returns
 */
const DivWFHF = ({
  className,
  children,
  ...restProps
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => (
  <div className={mergeClass("w-full h-full", className)} {...restProps}>
    {children}
  </div>
);

/**
 * Screen Border QOF component
 * @returns
 */
const Border = () => <div className="border border-gray-500 w-full h-full" />;

const getTextSlideData = (itemData: any) => {
  return {
    bgColor: itemData?.backgroundColor || "#ffffff",
    pictogram: getPictogramFileByName(itemData.pictogram || ""),
    hasTitle: itemData.title && itemData.title.length > 0,
    darkBg: itemData.backgroundColor === "#000000",
  };
};

const WaveImage = ({
  darkBg,
  className,
}: {
  darkBg: boolean;
  className?: string;
}) => (
  <img
    src="/assets/wave_preview.png"
    className={mergeClass(
      "absolute left-0 top-[15px]",
      {
        "filter brightness-0": !darkBg,
      },
      className
    )}
  />
);

/**
 * Get background color label from options
 */
const getBackgroundColorLabelFromString = (val: string) => {
  const array = dropdownFields.find(
    (f) => f.field === "backgroundColor"
  )?.options;
  if (!array) return `Unlisted colour - ${val}`;
  const color = array.find((c) => c.value === val);
  if (!color) return `Unlisted colour - ${val}`;
  return color?.label;
};

export type { IPreviewProps };
export {
  DivWFHF,
  Border,
  getTextSlideData,
  WaveImage,
  getBackgroundColorLabelFromString,
};
